import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@nexelem/api';

export const useCompetenceCategories = (enabled?: boolean) => {
  const api = useAPI();

  return useQuery({
    queryKey: ['competence-categories'],
    queryFn: () =>
      api
        .postBackWorkersCompetenceCategoriesListFilter({
          postBackWorkersCompetenceCategoriesListFilterRequest: {
            data: {},
          },
        })
        .then((res) => res.result.data),
    enabled,
  });
};
